import React from 'react';
import classNames from 'classnames';
import { useConfig } from '../../contexts/config-context';
import Fieldset from '../fieldset';
import { classes } from './date-field.st.css';
import { DatePicker } from '../date-picker';
export function DateField(_ref) {
  let {
    onBlur,
    onChange,
    onFocus,
    inputId,
    ariaLabelledBy,
    value,
    id,
    disabled,
    errors,
    hidePlaceholder,
    showDateLabels,
    required,
    ariaDescribedBy
  } = _ref;
  const {
    isMobile
  } = useConfig();
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    onFocus: onFocus,
    onBlur: onBlur,
    ariaLabelledBy: ariaLabelledBy,
    className: classNames(classes.fields, {
      [classes.mobile]: isMobile
    }),
    ariaDescribedBy: ariaDescribedBy,
    required: required
  }, /*#__PURE__*/React.createElement(DatePicker, {
    inputId: inputId,
    disabled: disabled,
    errors: errors,
    hidePlaceholder: hidePlaceholder,
    showDateLabels: showDateLabels,
    required: required,
    id: id,
    onChange: onChange,
    value: value
  }));
}
//# sourceMappingURL=date-field.js.map